import type { newCouponType } from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import { getAppConfiguration } from "appConfig";

export async function getCouponsList() {
  const appConfiguration = await getAppConfiguration();
  return axiosFetch.get(`/api/Coupon/all/${appConfiguration.providerId}`);
}

export async function getCustomCouponsList(providerId: string) {
  return axiosFetch.get(`/api/Coupon/all/${providerId}`);
}

export async function postCoupon(body: newCouponType) {
  return axiosFetch.post("/api/Coupon/upsert", {
    ...body,
  });
}

export async function getCouponById(couponId: string) {
  return axiosFetch.get(`/api/Coupon/${couponId}`);
}
